const BAD_REQUEST = /^(400\s*)?bad request\.?$/i;

// Текст ошибки из тела ответа: {message: '...'}, {error: '...'} или {error: {message: '...'}}.
// Пустая строка — если текста нет или это бесполезное для пользователя "Bad request".
export const parseErrorMessage = (text) => {
  let data;
  try {
    data = JSON.parse(text);
  } catch {
    return '';
  }
  const error = data?.error;
  const message = data?.message || (typeof error === 'string' ? error : error?.message);
  if (typeof message !== 'string') return '';
  const trimmed = message.trim();
  return BAD_REQUEST.test(trimmed) ? '' : trimmed;
};
